/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface NotificaPushDestinatariDTO { 
    /**
     * Numero di dispositivi che l\'invio raggiungerebbe con questi criteri.
     */
    dispositivi?: number;
    /**
     * Id del Comune applicato come filtro; assente se nessun filtro.
     */
    comune_id?: string;
    /**
     * Vero se il filtro Comune e\' attivo: in quel caso il conteggio include solo i cittadini con almeno una pratica in quel Comune.
     */
    filtro_comune_attivo?: boolean;
    /**
     * Id del cittadino di cui si sono contati i dispositivi; assente quando il conteggio riguarda un invio globale.
     */
    user_id?: string;
}

